import { Controller } from "@hotwired/stimulus";
import { applyProjects, bindMailMode, bindProjectsPicker, openProjectsDialog } from "@/src/easy_notification_settings";

export default class extends Controller {
  connect() {
    bindMailMode(this.element);
    bindProjectsPicker(this.element);
  }

  open() {
    openProjectsDialog();
  }

  /** @param {Event} event */
  apply(event) {
    applyProjects(/** @type {HTMLElement} */ (event.currentTarget));
  }

  /** @param {Event} event */
  cancel(event) {
    const dialog = /** @type {(HTMLElement & { close?: () => void }) | null} */ (
      /** @type {HTMLElement} */ (event.currentTarget).closest("easy8-ds-dialog")
    );
    dialog?.close?.();
  }
}
